<section
  class="chat-page"
  [class.chat-page--embedded]="embeddedDesktop()"
  [class.chat-page--thread-open]="hasOpenThread() && !embeddedDesktop()">
  @if (!embeddedDesktop()) {
    <app-mobile-page-header
      class="chat-mobile-header"
      [title]="i18n.t('route.chat')"
      [backLabel]="i18n.t('common.back')"
      [showBack]="hasOpenThread()"
      (back)="onMobileHeaderBack()" />
  }

  <div
    class="chat-page__inner"
    [class.chat-page__inner--thread-open]="hasOpenThread()"
    [class.chat-page__inner--full-height]="hasOpenThread() && !embeddedDesktop()">
    <div class="chat-list-panel">

      @if (isLoadingList()) {
        <div class="chat-empty-state">
          <p>{{ i18n.t('chat.loading') }}</p>
        </div>
      } @else if (chats().length) {
        <div class="chats-list">
          @for (chat of chats(); track trackByChatId($index, chat)) {
            <button
              type="button"
              class="chat-item"
              [class.chat-item--active]="chat.id === activeChatId()"
              (click)="onSelectChat(chat.id)">
              <p class="chat-info">
                <img [alt]="chat.title" [src]="chatAvatar(chat)" class="chat-avatar" />
                {{ chat.title }}

                @if (chat.unread_amount) {
                  <span class="new-messages-label">{{ chat.unread_amount }}</span>
                }
              </p>

              <span class="chat-date">
                @if (chat.last_message) {
                  {{ chat.last_message.timestamp / 1000000 | date: 'dd.MM.yyyy HH:mm' }}
                }
              </span>
            </button>
          }
        </div>
      } @else {
        <div class="chat-empty-state">
          <p>{{ i18n.t('chat.empty') }}</p>
        </div>
      }
    </div>

    <div class="chat-thread-panel" [class.chat-thread-panel--open]="hasOpenThread()">
      @if (activeChat()) {
        <div class="chat-content">
          <div class="chat-heading">
            <div class="chat-title wrap">
              <button type="button" class="custom-btn chat-control-btn close-chat-btn" (click)="onCloseThread()">
                <img [alt]="i18n.t('chat.closeChat')" src="/static_images/ic_chevron_right.svg" />
              </button>
              <span class="chat-label">{{ shellTitle() }}</span>
            </div>

            <div class="adv-info">
              <a [routerLink]="['/ad', activeChat()!.realty_id]" class="adv-link">
                <img [alt]="activeChat()!.title" [src]="chatAvatar(activeChat())" class="chat-avatar" />
                {{ activeChat()!.title }}
                <button type="button" class="custom-btn chat-control-btn right-btn">
                  <img [alt]="i18n.t('chat.openListing')" src="/static_images/ic_chevron_right.svg" class="link-arrow" />
                </button>

                @if (activeChatPriceLabel()) {
                  <span class="price-label">{{ activeChatPriceLabel() }}</span>
                }
              </a>
            </div>
          </div>

          <div class="chat-messages-container">
            <div class="chat-messages">
              @if (isLoadingThread()) {
                <div class="chat-empty-state chat-empty-state--thread">
                  <p>{{ i18n.t('chat.loading') }}</p>
                </div>
              } @else {
                @for (message of messages(); track trackByMessageId($index, message)) {
                  @if ($index === 0 || messages()[$index - 1].displayDate !== message.displayDate) {
                    <div class="date-group-label">{{ message.displayDate }}</div>
                  }

                  <div class="chat-message" [class.my-message]="message.mine" [class.user-message]="!message.mine">
                    <div class="message-container">
                      <div class="message-text">
                        {{ message.text }}

                        <span class="message-status" [class.is-seen]="message.status">
                          <img alt="Message seen" src="/static_images/ic_check.svg" />
                        </span>
                        <span class="message-time">{{ message.displayTime }}</span>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>

          <div class="chat-control-block">
            <form class="chat-form" (ngSubmit)="onSendMessage()">
              <textarea
                name="text"
                class="chat-message-input"
                [placeholder]="i18n.t('chat.messagePlaceholder')"
                rows="2"
                [ngModel]="messageDraft()"
                (ngModelChange)="onDraftChange($event)"></textarea>

              <button type="submit" class="custom-btn send-message-btn" [disabled]="!messageDraft().trim() || isSending()">
                <img alt="Send message" src="/static_images/ic_send.svg" />
              </button>
            </form>
          </div>
        </div>
      } @else {
        <div class="chat-empty-state chat-empty-state--thread">
          <p>{{ i18n.t('chat.choose') }}</p>
        </div>
      }
    </div>
  </div>

  @if (loadError()) {
    <p class="chat-error">{{ loadError() }}</p>
  }
</section>
